module.exports = __webpack_public_path__ + "static/media/phone-11-pro-back.12b5a2f3.png";